module.exports = "pegasus_template/assets/theme4/img1x.png";